import { parsePhoneNumberWithError } from 'libphonenumber-js/max';

export const PHONE_ERROR = 'Controlla il numero di telefono: per un cellulare italiano usa +39 3…, senza lo zero; per un fisso mantieni lo zero del prefisso.';

// Contact validation only. Never changes caller IDs, assigned DIDs or routing.
export function normalizeRestaurantPhone(value) {
  const input = String(value || '').trim().replace(/^00/, '+');
  try {
    const phone = parsePhoneNumberWithError(input, { defaultCountry: 'IT', extract: false });
    if (!phone.isValid() || phone.ext) throw new Error('invalid');
    return phone.number;
  } catch { throw new Error(PHONE_ERROR); }
}

export function displayRestaurantPhone(value) {
  if (!value) return 'Non indicato';
  try {
    const phone = parsePhoneNumberWithError(String(value), { defaultCountry: 'IT', extract: false });
    return phone.isValid() && !phone.ext ? phone.formatInternational() : value;
  } catch { return value; }
}
